import { FC, HTMLAttributes } from 'react'

export const BackIcon:FC<HTMLAttributes<SVGElement> & { color?: string, onClick?: () => void }> = ({ color = '#306FD1', onClick, ...rest }) => (
  <svg {...rest} onClick={onClick} width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2273 1.68664C10.6065 1.28513 10.5885 0.652221 10.1869 0.273002C9.78544 -0.106217 9.15253 -0.0881455 8.77331 0.313366L0.272999 9.31337C-0.0909785 9.69874 -0.0910027 10.3012 0.272944 10.6866L8.77326 19.688C9.15244 20.0896 9.78535 20.1077 10.1869 19.7285C10.5884 19.3493 10.6066 18.7164 10.2274 18.3149L2.37546 10.0001L10.2273 1.68664Z" fill={color} />
  </svg>
)
